/**
 * Capture an invitation code across the first-party sign-in flow. Session
 * storage deliberately limits the lifetime to this tab; the code is removed
 * as soon as the authoritative account mutation accepts or rejects it.
 */
let MoonfallReferralLink;

(function () {
  'use strict';

  const STORAGE_KEY = 'moonfall.pendingReferralCode';
  const CODE_RE = /^[0-9a-f]{32}$/;

  function normalize(value) {
    return typeof value === 'string' && CODE_RE.test(value) ? value : null;
  }

  function getPendingCode() {
    try {
      return normalize(window.sessionStorage.getItem(STORAGE_KEY));
    } catch (_) {
      return null;
    }
  }

  function clearPendingCode(expectedCode) {
    const expected = normalize(expectedCode);
    if (!expected || getPendingCode() !== expected) return false;
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return true;
    } catch (_) {
      return false;
    }
  }

  function captureFromLocation() {
    let url;
    try {
      url = new URL(window.location.href);
    } catch (_) {
      return null;
    }
    const referralCode = normalize(url.searchParams.get('ref'));
    if (!referralCode) return null;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, referralCode);
    } catch (_) {
      return null;
    }

    // Keep UTM attribution but remove the bearer-like invitation code from the
    // address bar, screenshots, copied URLs, and subsequent Referer headers.
    url.searchParams.delete('ref');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    return referralCode;
  }

  MoonfallReferralLink = {
    captureFromLocation,
    clearPendingCode,
    getPendingCode,
  };
  captureFromLocation();
})();

export { MoonfallReferralLink };
